import { FC, PropsWithChildren } from 'react';

import { LDProvider } from 'launchdarkly-react-client-sdk';
import { LDContext } from 'launchdarkly-js-client-sdk';

import LaunchDarklyGate from './LaunchDarklyGate';

type Props = {
    clientSideID: string;
    useLaunchDarklyContext: () => LDContext | undefined;
};

export const LaunchDarklyProvider: FC<PropsWithChildren<Props>> = ({
    clientSideID,
    useLaunchDarklyContext,
    children,
}) => {
    const context = useLaunchDarklyContext();

    if (!context) {
        return null;
    }

    return (
        <LDProvider
            clientSideID={clientSideID}
            deferInitialization={true}
            context={context}
        >
            <LaunchDarklyGate>{children}</LaunchDarklyGate>
        </LDProvider>
    );
};

export default LaunchDarklyProvider;
